import { connect } from 'react-redux';

import UserGroupMembersEditor from '../components/UserGroupMembersEditor';
import { defaultMapDispatchToProps } from '../utils/ConnectDefaults';


export default connect(
  null,
  defaultMapDispatchToProps
)(UserGroupMembersEditor);